var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:`convention-sections-table-cell ${_vm.isActive ? 'isActive' : ''} ${
            _vm.isActive && _vm.isCommon ? 'common' : ''
        }`,on:{"click":function($event){return _vm.onClick()}}},[(_vm.inactiveStatusLabel)?_c('typo',{attrs:{"name":"body-10-normal"}},[_vm._v(" "+_vm._s(_vm.inactiveStatusLabel)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }